export default "__VITE_ASSET__jCmX8NqL__"